import React, { useState } from "react";
import {
  View,
  Text,
  Image,
  Dimensions,
  Animated,
  TouchableOpacity,
  StyleSheet,
  ScrollView,
  FlatList,
  TextInput,
} from "react-native";
import Header from "../../component/header";
import Background from "../../component/background";
import PrelimDetail from "../../component/prelimDetail";
import { createApprobation } from "../../action/authAction";
import Modal from "modal-react-native-web";
import { MaterialCommunityIcons } from "@expo/vector-icons";
const { width, height } = Dimensions.get("window");
export default function index({ navigation, route }) {
  const [modal, setModal] = useState(false);
  const [agreement, setAgreement] = useState(false);

  console.log(route.params);
  return (
    <View style={styles.container}>
      <Header
        onPressHome={() => {
          navigation.navigate("HomeUser");
        }}
        onPressCompetition={() => {
          navigation.navigate("CompetitionUser");
        }}
        onPressAthlete={() => {
          navigation.navigate("AthleteUser");
        }}
        onPressLogout={() => {
          navigation.navigate("Login");
        }}
        backgroundColorCompetition="#FFFFFF"
        User
        navigation={navigation}
      />
      <ScrollView>
        <View>
          <Background
            navigation={navigation}
            Title={`COMPETITIONS/${route.params.name}/PRELIMINARY ENTRY SUBMIT`}
          />
          <View
            style={
              width >= 1280 ? styles.viewDetail : stylesResponsive.viewDetail
            }
          >
            <PrelimDetail
              approbation_details={route.params.body.approbation_details}
            />
            <View
              style={{
                flexDirection: "row",
                alignSelf: "center",
                marginTop: height * 0.07,
              }}
            >
              <TouchableOpacity
                onPress={() => {
                  navigation.goBack();
                }}
                style={styles.buttonEdit}
              >
                <Text style={styles.textButton}>EDIT</Text>
              </TouchableOpacity>
              <TouchableOpacity
                onPress={() => {
                  setModal(true);
                }}
                style={styles.buttonSubmit}
              >
                <Text style={styles.textButton}>SUBMIT</Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
        <Modal
          transparent={true}
          visible={modal}
          onRequestClose={() => {
            Alert.alert("Modal has been closed.");
            setModal(!modal);
          }}
        >
          <View style={styles.bgModal}>
            <View
              style={{
                backgroundColor: "#FFFFFF",
                width: "100%",
                maxWidth: 920,
                height: 318,
                borderRadius: 10,
                borderWidth: 1,
                borderColor: "#2B6AB1",
                paddingVertical: 45,
                paddingHorizontal: 20,
                alignItems: "center",
                alignSelf: "center",
              }}
            >
              <Text
                style={{
                  fontSize: 18,
                  fontFamily: "Prompt",
                  color: "#C52020",
                  textAlign: "center",
                }}
              >
                Before you submit your entries via the link, please ensure that
                all information are correctly filled, as amendment will not be
                entertained.
              </Text>
              <View
                style={{
                  flexDirection: "row",
                  marginVertical: 50,
                  alignItems: "center",
                }}
              >
                <TouchableOpacity
                  onPress={() => {
                    setAgreement((val) => !val);
                  }}
                >
                  <MaterialCommunityIcons
                    name={
                      agreement ? "checkbox-marked" : "checkbox-blank-outline"
                    }
                    size={24}
                    color="#2B6AB1"
                  />
                </TouchableOpacity>
                <Text
                  style={{
                    fontSize: 18,
                    fontFamily: "Prompt",
                    color: "#2B6AB1",
                    marginLeft: 20,
                  }}
                >
                  I agree that I have filled up all information correct
                </Text>
              </View>
              <View style={{ flexDirection: "row" }}>
                <TouchableOpacity
                  disabled={!agreement}
                  onPress={async () => {
                    if (agreement) {
                      const { body, token } = route.params;
                      console.log("body >> ", body, token);
                      const response = await createApprobation({
                        state: body,
                        token: token,
                      });
                      console.log(response);
                      if (response) {
                        navigation.navigate("CompetitionUser");
                        setModal(!modal);
                      }
                    }
                  }}
                  style={{
                    width: 109,
                    height: 35,
                    backgroundColor: agreement ? "#B2FFAC" : "#d2d2d2",
                    borderWidth: 1,
                    borderColor: agreement ? "#2BB165" : "#d2d2d2",
                    borderRadius: 5,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Text
                    style={{
                      fontSize: 18,
                      fontFamily: "Prompt",
                      color: agreement ? "#2BB165" : "#fff",
                    }}
                  >
                    CONFIRM
                  </Text>
                </TouchableOpacity>
                <TouchableOpacity
                  onPress={() => {
                    setModal(!modal);
                  }}
                  style={{
                    width: 109,
                    height: 35,
                    backgroundColor: "#FFBEBE",
                    borderWidth: 1,
                    borderColor: "#FF4646",
                    borderRadius: 5,
                    justifyContent: "center",
                    alignItems: "center",
                    marginLeft: 74,
                  }}
                >
                  <Text
                    style={{
                      fontSize: 18,
                      fontFamily: "Prompt",
                      color: "#FF4646",
                    }}
                  >
                    CANCEL
                  </Text>
                </TouchableOpacity>
              </View>
            </View>
          </View>
        </Modal>
      </ScrollView>
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#CCE4FF",
    flexDirection: "row",
  },
  viewDetail: {
    width: width * 0.75,
    backgroundColor: "#FFFFFF",
    alignSelf: "center",
    marginVertical: 36,
    borderRadius: 46,
    paddingHorizontal: 45,
    paddingVertical: 39,
  },
  textButton: {
    fontSize: 20,
    fontFamily: "Prompt",
    color: "#FFFFFF",
    alignSelf: "center",
  },
  buttonEdit: {
    width: 99,
    height: 40,
    backgroundColor: "#2B6AB1",
    justifyContent: "center",
    marginHorizontal: 20,
    borderRadius: 10,
  },
  buttonSubmit: {
    width: 127,
    height: 40,
    backgroundColor: "#FFBC1E",
    justifyContent: "center",
    marginHorizontal: 20,
    borderRadius: 10,
  },
  bgModal: {
    width: "100%",
    height: "100%",
    backgroundColor: "#000000bb",
    justifyContent: "center",
  },
});
const stylesResponsive = StyleSheet.create({
  viewDetail: {
    width: width * 0.9,
    backgroundColor: "#FFFFFF",
    alignSelf: "center",
    marginVertical: 36,
    borderRadius: 46,
    paddingHorizontal: 45,
    paddingVertical: 39,
  },
});
